import { withDefaults } from '@warp-drive/legacy/model/migration-support';

const OwnerSchema = withDefaults({
  type: 'owner',
  fields: [
    {
      kind: 'hasMany',
      name: 'schedules',
      type: 'schedule',
      options: {
        async: false,
        inverse: 'owner',
        as: 'owner',
      },
    },
  ],
});

export default OwnerSchema;
